import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import {
  FullWidth,
  BannerTitle,
  BannerSubtitle,
  BannerButtonContainer,
} from "../styles/styled-components/bannerStyles"
import BannerButton from "../models/bannerButton"

const BannerWithButtons = ({ image, title, subtitle, buttons }) => {
  return (
    <FullWidth
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0, 0.7), rgba(0,0,0, 0.7)), url(${
          !!image.childImageSharp ? image.childImageSharp.fluid.src : image
        })`,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="has-text-centered">
          <div style={{ lineHeight: 1 }}>
            <BannerTitle className="has-text-weight-bold is-size-3-mobile is-size-2-tablet is-size-1-widescreen">
              {title}
            </BannerTitle>
            <BannerSubtitle className="is-size-5-mobile is-size-4-tablet is-size-3-widescreen">
              {subtitle}
            </BannerSubtitle>
          </div>
        </div>

        <BannerButtonContainer className="has-text-centered">
          {buttons &&
            buttons.map(button => (
              <Link
                key={button.text}
                className={`button is-rounded is-medium ${button.background} ${button.color}`}
                to={button.to}
                state={button.state}
              >
                {button.text}
              </Link>
            ))}
        </BannerButtonContainer>
      </div>
    </FullWidth>
  )
}

BannerWithButtons.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.instanceOf(BannerButton)),
}

export default BannerWithButtons
